module.exports = __webpack_public_path__ + "static/press-logo-91bee58d0bd575ed95c0f4fd79d34012.svg";